<div class="template-details-view-container" *ngIf="templateObject" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).template.write" (click)="modify()" mat-stroked-button
            color="primary">
      <mat-icon>create</mat-icon>
      <span> Edytuj</span></button>
    <button [disabled]="!(userPermissions | async).template.read" (click)="download()" mat-stroked-button
            color="accent">
      <mat-icon>download</mat-icon>
      <span> Pobierz</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane szablonu</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Nazwa" [value]="templateObject.name"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Typ szablonu" [value]="templateObject.type?.name"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px"
                 *ngIf="[TEMPLATE_TYPE_AGENT_POWER_OF_ATTORNEY].includes(templateObject.type.key)">
              <div fxFlex="50">
                <app-detail header="Obowiązuje od" [value]="templateObject.validFrom | date:'y-MM-dd'"></app-detail>
              </div>
            </div>
            <!--            <div fxLayout="column" fxLayoutGap="15px">-->
            <!--              <div fxFlex="100">-->
            <!--                <app-detail header="Link publiczny APK" [value]="publicLink(templateObject.fileLocation)"></app-detail>-->
            <!--              </div>-->
            <!--              <div fxFlex="100">-->
            <!--                <h3>Historia pliku</h3>-->
            <!--                <ng-container *ngFor="let templateHistory of templateObject.templatesFileHistory">-->
            <!--                  <app-detail header="Link publiczny APK"-->
            <!--                              [value]="publicLink(templateHistory.fileLocation)"></app-detail>-->
            <!--                </ng-container>-->
            <!--              </div>-->
            <!--            </div>-->
          </mat-card>
        </div>
      </div>
    </div>
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%"
           *ngIf="[TEMPLATE_TYPE_ANNEX_COMMISSION_ATTACHMENT, TEMPLATE_TYPE_ANNEX_OFWCA_APPLICATION, TEMPLATE_TYPE_ANNEX_LEAD_TEMPLATE, TEMPLATE_TYPE_ANNEX_AUTOMATIC_BILLING, TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_AND_AUTOMATIC_BILLING, TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_WITHOUT_AUTOMATIC_BILLING].includes(templateObject.type.key)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane umowy</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Typ umowy" [value]="templateObject.contractType?.name"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Firma" [value]="templateObject.company?.name"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Strona umowy" [value]="templateObject.owner?.name"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Forma prawna" [value]="templateObject.legalForm?.name"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Typ działalności"
                          [value]="templateObject.formOfBusiness?.name"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%"
           *ngIf="[TEMPLATE_TYPE_CONTRACT, TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE].includes(templateObject.type.key)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane umowy</h3>
            </div>

            <div fxLayout="row" *ngIf="[TEMPLATE_TYPE_CONTRACT].includes(templateObject.type.key)">
              <app-detail-bool fxFlex="100" header="Aneks" [value]="templateObject.annex"></app-detail-bool>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Typ umowy" [value]="templateObject.contractType.name"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Firma" [value]="templateObject.company.name"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Strona umowy" [value]="templateObject.owner?.name"></app-detail>
            </div>

            <div fxLayout="row" *ngIf="templateObject.legalForm">
              <app-detail fxFlex="100" header="Forma prawna" [value]="templateObject.legalForm?.name"></app-detail>
            </div>

            <div fxLayout="row" *ngIf="templateObject.formOfBusiness">
              <app-detail fxFlex="100" header="Typ działalności"
                          [value]="templateObject.formOfBusiness?.name"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="[ TEMPLATE_TYPE_TERMINATION].includes(templateObject.type.key)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane umowy</h3>
            </div>

            <div fxLayout="row">
              <app-detail-bool fxFlex="100" header="Aneks" [value]="templateObject.annex"></app-detail-bool>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Typ umowy" [value]="templateObject.contractType.name"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Firma" [value]="templateObject.company.name"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Strona umowy" [value]="templateObject.owner?.name"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Forma prawna" [value]="templateObject.legalForm?.name"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%"
           *ngIf="[TEMPLATE_TYPE_STATEMENT, TEMPLATE_TYPE_AGENT_POWER_OF_ATTORNEY].includes(templateObject.type.key)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane rejestracji</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="TU" [value]="templateObject.insuranceCompany?.name"
                          [link]="['/tu/szczegoly', templateObject.insuranceCompany?.id]"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Firma">
                <mat-chip-list>
                  <ng-container *ngFor="let company of templateObject.companies; let last = last">
                    <mat-chip color="accent" selected>{{ company.name }}</mat-chip>
                  </ng-container>
                </mat-chip-list>
              </app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Typ umowy" [value]="templateObject.contractType?.name"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%"
           *ngIf="[TEMPLATE_TYPE_AUTHORIZATION, TEMPLATE_TYPE_DECLARATION_FOR_DEREGISTRATION].includes(templateObject.type.key)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane rejestracji</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="TU" [value]="templateObject.insuranceCompany?.name"
                          [link]="['/tu/szczegoly', templateObject.insuranceCompany?.id]"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Firma" [value]="templateObject.company.name"></app-detail>
            </div>

            <div fxLayout="row" *ngIf="[TEMPLATE_TYPE_AUTHORIZATION].includes(templateObject.type.key)">
              <app-detail fxFlex="100" header="Typ umowy" [value]="templateObject.contractType?.name"></app-detail>
            </div>
          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="[TEMPLATE_TYPE_PARTNER_DATA].includes(templateObject.type.key)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane Partnera</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Forma prawna" [value]="templateObject.legalForm?.name"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>


      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="[TEMPLATE_TYPE_OFWCA_APPLICATION,
       TEMPLATE_TYPE_CONTRACT_WITH_EMPLOYEE, TEMPLATE_TYPE_INFORMATION_ABOUT_RODO,
       TEMPLATE_TYPE_DISTRIBUTOR_INFORMATION].includes(templateObject.type.key)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane zgłoszenia</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Firma" [value]="templateObject.company?.name"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%"
           *ngIf="[ TEMPLATE_TYPE_DECLARATION_FOR_DEREGISTRATION].includes(templateObject.type.key)">
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Konfiguracja pliku</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Typ pliku" [value]="templateObject.fileExtension?.name"></app-detail>
            </div>


            <!--            <div fxLayout="row" fxLayoutGap="15px">-->
            <!--              <div fxFlex="100" >-->
            <!--                <table fxFlex="100">-->
            <!--                  <tr *ngFor="let sortItem of sortItems">-->
            <!--                    <td *ngFor="let item of sortItem" >-->
            <!--                      <mat-checkbox-->
            <!--                        (change)="add(item)"-->
            <!--                        [checked]="isSelect(item.key)">-->
            <!--                        {{item.name}}-->
            <!--                      </mat-checkbox>-->
            <!--                    </td>-->
            <!--                  </tr>-->
            <!--                </table>-->
            <!--              </div>-->
            <!--            </div>-->

            <div fxLayout="row" *ngIf="templateObject.startingFieldX">
              <app-detail fxFlex="50" header="Pozycja startowa Wiersza"
                          [value]="templateObject.startingFieldX"></app-detail>
              <app-detail fxFlex="50" header="Pozycja startowa Kolumny"
                          [value]="templateObject.startingFieldY"></app-detail>
            </div>


          </mat-card>
        </div>
      </div>

    </div>
  </div>
  <div fxLayout="column" fxLayoutGap="15px"
       *ngIf="[TEMPLATE_TYPE_AGENT_POWER_OF_ATTORNEY, TEMPLATE_TYPE_INFORMATION_ABOUT_RODO, TEMPLATE_TYPE_DISTRIBUTOR_INFORMATION].includes(templateObject.type.key) && (userPermissions | async).template.admin_root">
    <div fxFlex="100">
      <mat-card>
        <h3 style="margin-bottom: 0">Plik aktualny</h3>

        <app-detail [header]="'Link publiczny APK'"
                    [value]="publicLink(templateObject.fileLocation)"></app-detail>
        <h3 style="margin-bottom: 0">Historia</h3>

        <ng-container *ngFor="let templateHistory of templateObject.templatesFileHistory">
          <app-detail header="Link publiczny APK"
                      [value]="publicLink(templateHistory.fileLocation)"></app-detail>
        </ng-container>
      </mat-card>
    </div>
  </div>

</div>
